// extracted by mini-css-extract-plugin
module.exports = {"cta":"FloatingActionButton_cta__2Isex","addIcon":"FloatingActionButton_addIcon__1dBLk"};